<template>
  <div>
    <div>
      <el-form
        :model="queryForm"
        :inline="true"
        style="text-align:left;"
        label-width="100px"
        class="queryform-class"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="承销商:" class="agent-select">
              <My-Select
                v-model="queryForm.agentCode"
                :objSelect="queryForm.agentCode"
                :options="agentList"
                :placeholder="agentPlaceholder"
                :optionBind="optionBindAgent"
                @changeSelct="changeAgent"
                :clearable="true"
              ></My-Select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="机构:" class="agent-select">
              <My-Select-All
                v-model="queryForm.agentBranCode"
                :objSelect="queryForm.agentBranCode"
                :placeholder="agentQueryPlaceholder"
                :optionBind="optionBindBran"
                :options="queryAgentBranList"
                @changeSelct="changeQueryAgentBran"
              ></My-Select-All>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="品类:" class="agent-select">
              <My-Select-All
                v-model="queryForm.dicTypeCode"
                :objSelect="queryForm.dicTypeCode"
                :options="categoryList"
                :placeholder="categoryPlaceholder"
                :optionBind="optionBindCategory"
                @changeSelct="changeCategorySelct"
                :clearable="true"
              ></My-Select-All>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
           <el-col :span="8">
            <el-form-item label="延保销售时间:" class="datatime-class">
              <el-date-picker
                v-model="queryForm.createTimeStart"
                type="datetime"
                placeholder="开始时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
              <span> - </span>
              <el-date-picker
                v-model="queryForm.createTimeEnd"
                type="datetime"
                default-time = "23:59:59"
                placeholder="结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="延保产品:" class="agent-select">
              <My-Select
                v-model="queryForm.prodName"
                :objSelect="queryForm.prodName"
                :options="ewProductList"
                :placeholder="ewPlaceholder"
                :optionBind="optionBindEw"
                @changeSelct="changeEwSelct"
                :clearable="true"
              ></My-Select>
            </el-form-item>
          </el-col>
         
        </el-row>
        <el-row>
          <el-col :span="9">
            <el-form-item label="审核通过时间:" class="datatime-class">
              <el-date-picker
                v-model="queryForm.passTimeStart"
                type="datetime"
                placeholder="开始时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
              <span> - </span>
              <el-date-picker
                v-model="queryForm.passTimeEnd"
                type="datetime"
                default-time = "23:59:59"
                placeholder="结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-button type="primary" plain @click="query()">查询</el-button>
            <el-button type="primary" plain @click="exportExt()">导出</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div>
      <My-table
        :configurationData="configurationData"
        :operation="operation"
        :getTableParam="getTableParam"
        ref="myTable"
      >
      </My-table>
    </div>
  </div>
</template>

<script>
import common from '../../../public/static/common';
import asyncApi from "../../api/asyncApi";
export default {
  name: "warrantySalesAnalysis",
  data() {
    return {
      agentPlaceholder: "请选择承销商名称",
      categoryPlaceholder: "请选择品类",
      ewPlaceholder: "请选择延保产品",
      agentQueryPlaceholder: "请选择机构",
      ewProductList: [],
      categoryList: [],
      queryAgentBranList: [],
      agentList: [],
      queryForm: {
        createTimeStart: "",
        createTimeEnd: "",
        passTimeStart: "", //TODO审核通过时间
        passTimeEnd: "",
        prodName: "",
        agentCode: "",
        dicTypeCode: [],
        agentBranCode: [],
        sysCode: 'PC'
      },
      optionBindEw: {
        label: "prodName",
        value: "prodCode"
      },
      optionBindCategory: {
        label: "dicTypeName",
        value: "dicTypeCode",
      },
      optionBindAgent: {
        label: "agentName",
        value: "agentCode",
      },
      optionBindBran: {
        label: "agentBranName",
        value: "agentBranCode",
      },
      // 列表配置
      configurationData: [
        {
          title: "承销商",
          propertys: "agentName",
          width: "",
        },
        {
          title: "机构",
          propertys: "agentBranName",
          width: ""
        },
        // {
        //   title: "延保产品",
        //   propertys: "prodName",
        //   width: "",
        // },
        {
          title: "品类",
          propertys: "dicTypeName",
          width: "",
        },
        {
          title: "延保销售单量",
          propertys: "count",
          width: "",
        },
        {
          title: "延保销售金额(元)",
          propertys: "salesMoney",
          width: "",
        }
      ],
      // 是否有操作按钮 宽度
      operation: {
        show: false,
        width: "",
      },
      getTableParam: {
        url: "/extwarapi/api/statistic/getSalesAnalysis",
        param: "",
      },
    };
  },
  methods: {
    query() {
      // 承销商不能为空
      // this.queryForm.agentCode=common.getCurrUserRoleList()[]
      if(this.queryForm.agentCode){
        this.getTableParam.param = this.queryForm;
        this.$refs["myTable"].query(1);
      }else {
        this.$alert("承销商不能为空!", '提示信息', {
            confirmButtonText: '确定'
        });
      }
      
    },
    // 延保产品
    changeEwSelct(value) {
      //console.log('ewselct',value,this.ewProductList)
      // this.queryForm.prodName = value;
      this.queryForm.prodCode = value
      for(let i=0;i<this.ewProductList.length;i++){
        if(this.ewProductList[i].prodName == value){
          this.queryForm.prodCode = this.ewProductList[i].prodCode
        }
      }
      //console.log('prodcode',this.queryForm.prodCode)
    },
    changeCategorySelct(value) {
      //console.log('ceate',value)
      this.queryForm.dicTypeCode = value;
    },
    changeAgent(value) {
      // 根据承销商来查
      // if(this.queryForm.agentCode !=value){
      //   this.queryForm.agentBranCode = ''
      //   this.queryForm.prodName = ''
      // }
      this.queryForm.agentCode = value;
      // this.getAgentBranList(value)
      // this.getCategory(value)
      // this.getEwProduct(value)
    },
    changeQueryAgentBran(value) {
      //console.log('value-11',value)
      this.queryForm.agentBranCode = value;
    },
    exportExt() {
      let url = "/extwarapi/api/statistic/getSalesAnalysisExport";
      let param = Object.assign({}, this.queryForm);
      param.pageNum = 1;
      param.pageSize = 9999;
      this.axios
        .post(url, param, { responseType: "blob" })
        .then((resp) => {
          let fileName = decodeURIComponent(
            resp.headers["content-disposition"]
          ).split("=")[1];
          let blob = new Blob([resp.data], { type: ".xlsx" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            let a = document.createElement("a");
            a.download = fileName;
            a.href = window.URL.createObjectURL(blob);
            a.click();
            //释放内存
            window.URL.revokeObjectURL(a.href);
          }
        })
        .catch((resp) => {
          //console.log("error", resp);
        });
    },
    //获取延保产品字典
    async getEwProduct() {
      let url = "/extwarapi/api/extension/getProdEnum";
      let code = {
        "code": ''
      }
      let data = await asyncApi.post(url, code);
      if (data.code == "0000") {
        this.ewProductList = data.result;
        //console.log('ewprodList',this.ewProductList)
      }
    },
    //获取承销商数据字典
    async getAgentList() {
      let url = "/extwarapi/api/agent/getAgentEnum";
      let code = {
        "code": ''
      }
      let data = await asyncApi.post(url, code);
      if (data.code == "0000") {
        this.agentList = data.result;
      }
      //console.log('queryForm',this.queryForm)
    },
    //获取品类产品字典
    async getCategory() {
      let url = "/extwarapi/api/dicProdType/getTypeEnum";
      // let url = "/extwarapi/api/dicProdType/getTypeEnumByAgentCode"
      // let code = {
      //   "agentCode": '',
      //   "userRole": ''
      // }
      // if(common.getCurrUserRoleList()[0].roleCode!='admin'){
      //   code.userRole = common.getCurrUserRoleList()[0].roleCode
      //   code.agentCode = common.getCurrUser().agentCode
      // }
      let data = await asyncApi.post(url, null);
      if (data.code == "0000") {
        this.categoryList = data.result;
      }
    },
    //获取机构字典
    async getAgentBranList() {
      let url = "/extwarapi/api/agent/getAgentBranchEnum";
      let code = {
        "code": ''
      }
      this.axios
        .post(url, code)
        .then((resp) => {
          if (resp.data.code == "0000") {
            this.queryAgentBranList = resp.data.result;
            //console.log('机构',this.queryAgentBranList)
          }
        })
        .catch((resp) => {
          //console.log("error", resp);
        });
    },
  },
  mounted() {
    this.getEwProduct();
    this.getAgentList();
    this.getCategory();
    this.getAgentBranList();
  },
};
</script>

<style lang="scss">
.queryform-class {
  .datatime-class .el-date-editor {
    width: 190px;
  }
  .prod-select .el-input__inner {
    width: 292px;
  }
  .agent-select .el-input__inner {
    width: 190px;
  }
}
</style>
